import { Pipe, PipeTransform } from '@angular/core';

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: August 16th 2018
 * 
 * Description: Component class to truncate content
 **/
@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const limit = args.length > 0 ? parseInt(args[0], 10) : 20;
    const trail = args.length > 1 ? args[1] : '...';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipe/truncate.pipe.ts